import {fromStorage, refreshState} from 'interactors/statePersistence';

import {TimeZoneShift} from './types';
import {calcShiftFromOriginalTimeZone} from './calcShiftFromOriginalTimeZone';
import {correctTimeZoneDependentDates} from './correctTimeZoneDependentDates';

function extractLastRecalcDateTime(state: StorableState): DayStartTimeStamp {
  const {lastRecalcDateTime} = state;
  return lastRecalcDateTime;
}

function isTimeZoneShifted(shift: TimeZoneShift): boolean {
  return shift !== 0;
}

export function checkUserTimeZoneShift(): void {
  const state = fromStorage();
  const original = extractLastRecalcDateTime(state);
  const shift = calcShiftFromOriginalTimeZone(original);
  if (!isTimeZoneShifted(shift)) return;

  const corrected = correctTimeZoneDependentDates(state, shift);
  refreshState(corrected);
}
